import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import Input from '@jetbrains/ring-ui/components/input/input';
import Select from '@jetbrains/ring-ui/components/select/select';
import { assignTestId } from '@common/infra/tests/assign-test-id';
import { useFeatureFlag } from '@common/server-config-context/server-config-context';
import styles from './version-selector.css';
export function VersionSelector(props) {
    const { version, onVersionChange } = props;
    const allowDenyPluginsListEnabled = useFeatureFlag('allowDenyPluginsListEnabled');
    const options = useMemo(() => [
        allowDenyPluginsListEnabled
            ? {
                label: 'All versions',
                key: 'all',
                type: 'all',
                ...assignTestId('all-versions')
            }
            : undefined,
        {
            label: 'Latest version',
            key: 'latest',
            type: 'latest',
            ...assignTestId('latest-version')
        },
        {
            label: 'Version',
            key: 'custom',
            type: 'custom',
            ...assignTestId('custom-version')
        }
    ].filter(Boolean), [allowDenyPluginsListEnabled]);
    const handleSelect = useCallback((value) => {
        switch (value === null || value === void 0 ? void 0 : value.type) {
            case 'all':
                return onVersionChange({ type: 'all' });
            case 'latest':
                return onVersionChange({ type: 'latest' });
            case 'custom':
                return onVersionChange({ type: 'custom', version: '' });
            default:
                return null;
        }
    }, [onVersionChange]);
    const selectedVersionType = useMemo(() => { var _a; return (_a = options.find(option => option.type === (version === null || version === void 0 ? void 0 : version.type))) !== null && _a !== void 0 ? _a : options[0]; }, [version, options]);
    const handleCustomVersionChange = useCallback((e) => {
        onVersionChange({ type: 'custom', version: e.target.value });
    }, [onVersionChange]);
    return (_jsxs("div", { ...assignTestId('version-selector'), className: styles.wrapper, children: [_jsx(Select, { ...assignTestId('version-type-selector'), className: styles.dropdown, onSelect: handleSelect, selected: selectedVersionType, data: options }), selectedVersionType.type === 'custom' && (_jsx(Input, { className: styles.versionInput, value: (version === null || version === void 0 ? void 0 : version.type) === 'custom' ? version.version : '', onChange: handleCustomVersionChange, ...assignTestId('custom-version-input') }))] }));
}
